// extracted by mini-css-extract-plugin
export default {"wrapper":"tag_wrapper__qOQML","inner":"tag_inner__nUW6z","inline":"tag_inline__9d5Qa","multiLine":"tag_multiLine__nz8hO"};